export { getApolloClient } from './client';
